import { createAuthContext } from "@intern/oidc-client";
import router from "./router";

let currentUser = null;

const baseAuthContext = createAuthContext({
  authorityUrl: process.env.VUE_APP_KEYCLOAK_URL,
  clientId: "user-management",
  requireLogin: false,
  onUserLoaded(user) {
    currentUser = user;
  },
  async onUserUnloaded() {
    currentUser = null;
    await router.replace({ path: "/" });
  },
});

export const authContext = {
  ...baseAuthContext,
  authenticated() {
    return currentUser != null;
  },
  get user() {
    return currentUser;
  },
};

/**
 * @param {RequestInfo} input
 * @param {RequestInit} init
 */
export async function fetchAPI(input, init = {}) {
  const res = await fetch("/api" + input, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authContext.user.token}`,
      ...init.headers,
    },
  });
  return res;
}
